<ul class="pagination main_block_bg justify-content-right py-3 px-1">
  <li class="page-item mono_bg" [class.disabled]="currentPage === 1">
    <a class="page-link mono_bg" (click)="prev()">Назад</a>
  </li>
  <li class="page-item mono_bg disabled">
    <a class="page-link mono_bg">{{ currentPage }} из {{ getPageCount() }}</a>
  </li>
  <li
    class="page-item mono_bg"
    [class.disabled]="currentPage === getPageCount()">
    <a class="page-link mono_bg" (click)="next()">Вперед</a>
  </li>
</ul>
